/** @jsx jsx */
import { Button } from "@cd2/components/build/es6"
import { css, jsx } from "@emotion/core"
import React from "react"
import { icons } from "../../../utils/icons"

export function SaveButton({ onClick, disabled }: { onClick(): void; disabled?: boolean }) {
  return (
    <Button
      onClick={onClick}
      leftIcon={icons.save}
      disabled={disabled}
      css={css`
        width: max-content;
      `}
    >
      Save
    </Button>
  )
}
